export default "__VITE_ASSET__yqdMPkXt__"